/**
 * @module CountryMapper
 * @description Provides a utility to map ISO 3166-1 alpha-2 country codes to full names.
 */
const countryData = {
  // الدول التي أدخلتها أولاً
  US: { en: "United States", ar: "الولايات المتحدة" },
  DE: { en: "Germany", ar: "ألمانيا" },
  GB: { en: "United Kingdom", ar: "المملكة المتحدة" },
  FR: { en: "France", ar: "فرنسا" },
  CA: { en: "Canada", ar: "كندا" },
  AU: { en: "Australia", ar: "أستراليا" },
  NL: { en: "Netherlands", ar: "هولندا" },
  JP: { en: "Japan", ar: "اليابان" },
  IT: { en: "Italy", ar: "إيطاليا" },
  ES: { en: "Spain", ar: "إسبانيا" },
  RU: { en: "Russia", ar: "روسيا" },
  CN: { en: "China", ar: "الصين" },
  IN: { en: "India", ar: "الهند" },
  BR: { en: "Brazil", ar: "البرازيل" },
  AE: { en: "United Arab Emirates", ar: "الإمارات العربية المتحدة" },
  TR: { en: "Turkey", ar: "تركيا" },
  HK: { en: "Hong Kong", ar: "هونغ كونغ" },
  SG: { en: "Singapore", ar: "سنغافورة" },

  // قائمة موسعة ببقية الدول
  AF: { en: "Afghanistan", ar: "أفغانستان" },
  AX: { en: "Åland Islands", ar: "جزر أولاند" },
  AL: { en: "Albania", ar: "ألبانيا" },
  DZ: { en: "Algeria", ar: "الجزائر" },
  AS: { en: "American Samoa", ar: "ساموا الأمريكية" },
  AD: { en: "Andorra", ar: "أندورا" },
  AO: { en: "Angola", ar: "أنغولا" },
  AI: { en: "Anguilla", ar: "أنغويلا" },
  AQ: { en: "Antarctica", ar: "القارة القطبية الجنوبية" },
  AG: { en: "Antigua and Barbuda", ar: "أنتيغوا وباربودا" },
  AR: { en: "Argentina", ar: "الأرجنتين" },
  AM: { en: "Armenia", ar: "أرمينيا" },
  AW: { en: "Aruba", ar: "أروبا" },
  AT: { en: "Austria", ar: "النمسا" },
  AZ: { en: "Azerbaijan", ar: "أذربيجان" },
  BS: { en: "Bahamas", ar: "جزر البهاما" },
  BH: { en: "Bahrain", ar: "البحرين" },
  BD: { en: "Bangladesh", ar: "بنغلاديش" },
  BB: { en: "Barbados", ar: "باربادوس" },
  BY: { en: "Belarus", ar: "بيلاروس" },
  BE: { en: "Belgium", ar: "بلجيكا" },
  BZ: { en: "Belize", ar: "بليز" },
  BJ: { en: "Benin", ar: "بنين" },
  BM: { en: "Bermuda", ar: "برمودا" },
  BT: { en: "Bhutan", ar: "بوتان" },
  BO: { en: "Bolivia", ar: "بوليفيا" },
  BA: { en: "Bosnia and Herzegovina", ar: "البوسنة والهرسك" },
  BW: { en: "Botswana", ar: "بوتسوانا" },
  BV: { en: "Bouvet Island", ar: "جزيرة بوفيه" },
  IO: {
    en: "British Indian Ocean Territory",
    ar: "إقليم المحيط الهندي البريطاني",
  },
  BN: { en: "Brunei Darussalam", ar: "بروناي" },
  BG: { en: "Bulgaria", ar: "بلغاريا" },
  BF: { en: "Burkina Faso", ar: "بوركينا فاسو" },
  BI: { en: "Burundi", ar: "بوروندي" },
  KH: { en: "Cambodia", ar: "كمبوديا" },
  CM: { en: "Cameroon", ar: "الكاميرون" },
  CV: { en: "Cape Verde", ar: "الرأس الأخضر" },
  KY: { en: "Cayman Islands", ar: "جزر كايمان" },
  CF: { en: "Central African Republic", ar: "جمهورية أفريقيا الوسطى" },
  TD: { en: "Chad", ar: "تشاد" },
  CL: { en: "Chile", ar: "تشيلي" },
  CX: { en: "Christmas Island", ar: "جزيرة كريسماس" },
  CC: { en: "Cocos (Keeling) Islands", ar: "جزر كوكوس" },
  CO: { en: "Colombia", ar: "كولومبيا" },
  KM: { en: "Comoros", ar: "جزر القمر" },
  CG: { en: "Congo", ar: "الكونغو" },
  CD: {
    en: "Congo, the Democratic Republic of the",
    ar: "جمهورية الكونغو الديمقراطية",
  },
  CK: { en: "Cook Islands", ar: "جزر كوك" },
  CR: { en: "Costa Rica", ar: "كوستاريكا" },
  CI: { en: "Côte d'Ivoire", ar: "ساحل العاج" },
  HR: { en: "Croatia", ar: "كرواتيا" },
  CU: { en: "Cuba", ar: "كوبا" },
  CW: { en: "Curaçao", ar: "كوراساو" },
  CY: { en: "Cyprus", ar: "قبرص" },
  CZ: { en: "Czech Republic", ar: "جمهورية التشيك" },
  DK: { en: "Denmark", ar: "الدنمارك" },
  DJ: { en: "Djibouti", ar: "جيبوتي" },
  DM: { en: "Dominica", ar: "دومينيكا" },
  DO: { en: "Dominican Republic", ar: "جمهورية الدومينيكان" },
  EC: { en: "Ecuador", ar: "الإكوادور" },
  EG: { en: "Egypt", ar: "مصر" },
  SV: { en: "El Salvador", ar: "السلفادور" },
  GQ: { en: "Equatorial Guinea", ar: "غينيا الاستوائية" },
  ER: { en: "Eritrea", ar: "إريتريا" },
  EE: { en: "Estonia", ar: "إستونيا" },
  ET: { en: "Ethiopia", ar: "إثيوبيا" },
  FK: { en: "Falkland Islands (Malvinas)", ar: "جزر فوكلاند" },
  FO: { en: "Faroe Islands", ar: "جزر فارو" },
  FJ: { en: "Fiji", ar: "فيجي" },
  FI: { en: "Finland", ar: "فنلندا" },
  GF: { en: "French Guiana", ar: "غيانا الفرنسية" },
  PF: { en: "French Polynesia", ar: "بولينيزيا الفرنسية" },
  TF: {
    en: "French Southern Territories",
    ar: "أراض فرنسية جنوبية وأنتارتيكية",
  },
  GA: { en: "Gabon", ar: "الغابون" },
  GM: { en: "Gambia", ar: "غامبيا" },
  GE: { en: "Georgia", ar: "جورجيا" },
  GH: { en: "Ghana", ar: "غانا" },
  GI: { en: "Gibraltar", ar: "جبل طارق" },
  GR: { en: "Greece", ar: "اليونان" },
  GL: { en: "Greenland", ar: "جرينلاند" },
  GD: { en: "Grenada", ar: "غرينادا" },
  GP: { en: "Guadeloupe", ar: "غوادلوب" },
  GU: { en: "Guam", ar: "غوام" },
  GT: { en: "Guatemala", ar: "غواتيمالا" },
  GG: { en: "Guernsey", ar: "غيرنزي" },
  GN: { en: "Guinea", ar: "غينيا" },
  GW: { en: "Guinea-Bissau", ar: "غينيا بيساو" },
  GY: { en: "Guyana", ar: "غيانا" },
  HT: { en: "Haiti", ar: "هايتي" },
  HM: {
    en: "Heard Island and McDonald Islands",
    ar: "جزيرة هيرد وجزر ماكدونالد",
  },
  VA: { en: "Holy See (Vatican City State)", ar: "الفاتيكان" },
  HN: { en: "Honduras", ar: "هندوراس" },
  HU: { en: "Hungary", ar: "المجر" },
  IS: { en: "Iceland", ar: "آيسلندا" },
  ID: { en: "Indonesia", ar: "إندونيسيا" },
  IR: { en: "Iran, Islamic Republic of", ar: "إيران" },
  IQ: { en: "Iraq", ar: "العراق" },
  IE: { en: "Ireland", ar: "أيرلندا" },
  IM: { en: "Isle of Man", ar: "جزيرة مان" },
  IL: { en: "Israel", ar: "إسرائيل" },
  JM: { en: "Jamaica", ar: "جامايكا" },
  JE: { en: "Jersey", ar: "جيرزي" },
  JO: { en: "Jordan", ar: "الأردن" },
  KZ: { en: "Kazakhstan", ar: "كازاخستان" },
  KE: { en: "Kenya", ar: "كينيا" },
  KI: { en: "Kiribati", ar: "كيريباتي" },
  KP: { en: "Korea, Democratic People's Republic of", ar: "كوريا الشمالية" },
  KR: { en: "Korea, Republic of", ar: "كوريا الجنوبية" },
  KW: { en: "Kuwait", ar: "الكويت" },
  KG: { en: "Kyrgyzstan", ar: "قيرغيزستان" },
  LA: { en: "Lao People's Democratic Republic", ar: "لاوس" },
  LV: { en: "Latvia", ar: "لاتفيا" },
  LB: { en: "Lebanon", ar: "لبنان" },
  LS: { en: "Lesotho", ar: "ليسوتو" },
  LR: { en: "Liberia", ar: "ليبيريا" },
  LY: { en: "Libya", ar: "ليبيا" },
  LI: { en: "Liechtenstein", ar: "ليختنشتاين" },
  LT: { en: "Lithuania", ar: "ليتوانيا" },
  LU: { en: "Luxembourg", ar: "لوكسمبورغ" },
  MO: { en: "Macao", ar: "ماكاو" },
  MK: { en: "Macedonia, the former Yugoslav Republic of", ar: "مقدونيا" },
  MG: { en: "Madagascar", ar: "مدغشقر" },
  MW: { en: "Malawi", ar: "مالاوي" },
  MY: { en: "Malaysia", ar: "ماليزيا" },
  MV: { en: "Maldives", ar: "جزر المالديف" },
  ML: { en: "Mali", ar: "مالي" },
  MT: { en: "Malta", ar: "مالطا" },
  MH: { en: "Marshall Islands", ar: "جزر مارشال" },
  MQ: { en: "Martinique", ar: "مارتينيك" },
  MR: { en: "Mauritania", ar: "موريتانيا" },
  MU: { en: "Mauritius", ar: "موريشيوس" },
  YT: { en: "Mayotte", ar: "مايوت" },
  MX: { en: "Mexico", ar: "المكسيك" },
  FM: {
    en: "Micronesia, Federated States of",
    ar: "ولايات ميكرونيسيا المتحدة",
  },
  MD: { en: "Moldova, Republic of", ar: "مولدوفا" },
  MC: { en: "Monaco", ar: "موناكو" },
  MN: { en: "Mongolia", ar: "منغوليا" },
  ME: { en: "Montenegro", ar: "الجبل الأسود" },
  MS: { en: "Montserrat", ar: "مونتسرات" },
  MA: { en: "Morocco", ar: "المغرب" },
  MZ: { en: "Mozambique", ar: "موزمبيق" },
  MM: { en: "Myanmar", ar: "ميانمار" },
  NA: { en: "Namibia", ar: "ناميبيا" },
  NR: { en: "Nauru", ar: "ناورو" },
  NP: { en: "Nepal", ar: "نيبال" },
  NC: { en: "New Caledonia", ar: "كاليدونيا الجديدة" },
  NZ: { en: "New Zealand", ar: "نيوزيلندا" },
  NI: { en: "Nicaragua", ar: "نيكاراغوا" },
  NE: { en: "Niger", ar: "النيجر" },
  NG: { en: "Nigeria", ar: "نيجيريا" },
  NU: { en: "Niue", ar: "نييوي" },
  NF: { en: "Norfolk Island", ar: "جزيرة نورفولك" },
  MP: { en: "Northern Mariana Islands", ar: "جزر ماريانا الشمالية" },
  NO: { en: "Norway", ar: "النرويج" },
  OM: { en: "Oman", ar: "عُمان" },
  PK: { en: "Pakistan", ar: "باكستان" },
  PW: { en: "Palau", ar: "بالاو" },
  PS: { en: "Palestinian Territory, Occupied", ar: "فلسطين" },
  PA: { en: "Panama", ar: "بنما" },
  PG: { en: "Papua New Guinea", ar: "بابوا غينيا الجديدة" },
  PY: { en: "Paraguay", ar: "باراغواي" },
  PE: { en: "Peru", ar: "بيرو" },
  PH: { en: "Philippines", ar: "الفلبين" },
  PN: { en: "Pitcairn", ar: "جزر بيتكيرن" },
  PL: { en: "Poland", ar: "بولندا" },
  PT: { en: "Portugal", ar: "البرتغال" },
  PR: { en: "Puerto Rico", ar: "بورتوريكو" },
  QA: { en: "Qatar", ar: "قطر" },
  RE: { en: "Réunion", ar: "ريونيون" },
  RO: { en: "Romania", ar: "رومانيا" },
  RW: { en: "Rwanda", ar: "رواندا" },
  BL: { en: "Saint Barthélemy", ar: "سان بارتيلمي" },
  SH: {
    en: "Saint Helena, Ascension and Tristan da Cunha",
    ar: "سانت هيلينا وأسينشين وتريستان دا كونا",
  },
  KN: { en: "Saint Kitts and Nevis", ar: "سانت كيتس ونيفيس" },
  LC: { en: "Saint Lucia", ar: "سانت لوسيا" },
  MF: { en: "Saint Martin (French part)", ar: "سان مارتان" },
  PM: { en: "Saint Pierre and Miquelon", ar: "سان بيير وميكلون" },
  VC: { en: "Saint Vincent and the Grenadines", ar: "سانت فينسنت والغرينادين" },
  WS: { en: "Samoa", ar: "ساموا" },
  SM: { en: "San Marino", ar: "سان مارينو" },
  ST: { en: "Sao Tome and Principe", ar: "ساو تومي وبرينسيب" },
  SA: { en: "Saudi Arabia", ar: "المملكة العربية السعودية" },
  SN: { en: "Senegal", ar: "السنغال" },
  RS: { en: "Serbia", ar: "صربيا" },
  SC: { en: "Seychelles", ar: "سيشل" },
  SL: { en: "Sierra Leone", ar: "سيراليون" },
  SX: { en: "Sint Maarten (Dutch part)", ar: "سينت مارتن" },
  SK: { en: "Slovakia", ar: "سلوفاكيا" },
  SI: { en: "Slovenia", ar: "سلوفينيا" },
  SB: { en: "Solomon Islands", ar: "جزر سليمان" },
  SO: { en: "Somalia", ar: "الصومال" },
  ZA: { en: "South Africa", ar: "جنوب أفريقيا" },
  GS: {
    en: "South Georgia and the South Sandwich Islands",
    ar: "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
  },
  SS: { en: "South Sudan", ar: "جنوب السودان" },
  LK: { en: "Sri Lanka", ar: "سريلانكا" },
  SD: { en: "Sudan", ar: "السودان" },
  SR: { en: "Suriname", ar: "سورينام" },
  SJ: { en: "Svalbard and Jan Mayen", ar: "سفالبارد ويان ماين" },
  SZ: { en: "Swaziland", ar: "إسواتيني" },
  SE: { en: "Sweden", ar: "السويد" },
  CH: { en: "Switzerland", ar: "سويسرا" },
  SY: { en: "Syrian Arab Republic", ar: "سوريا" },
  TW: { en: "Taiwan, Province of China", ar: "تايوان" },
  TJ: { en: "Tajikistan", ar: "طاجيكستان" },
  TZ: { en: "Tanzania, United Republic of", ar: "تنزانيا" },
  TH: { en: "Thailand", ar: "تايلاند" },
  TL: { en: "Timor-Leste", ar: "تيمور الشرقية" },
  TG: { en: "Togo", ar: "توغو" },
  TK: { en: "Tokelau", ar: "توكيلاو" },
  TO: { en: "Tonga", ar: "تونغا" },
  TT: { en: "Trinidad and Tobago", ar: "ترينيداد وتوباغو" },
  TN: { en: "Tunisia", ar: "تونس" },
  TM: { en: "Turkmenistan", ar: "تركمانستان" },
  TC: { en: "Turks and Caicos Islands", ar: "جزر توركس وكايكوس" },
  TV: { en: "Tuvalu", ar: "توفالو" },
  UG: { en: "Uganda", ar: "أوغندا" },
  UA: { en: "Ukraine", ar: "أوكرانيا" },
  UY: { en: "Uruguay", ar: "الأوروغواي" },
  UZ: { en: "Uzbekistan", ar: "أوزبكستان" },
  VU: { en: "Vanuatu", ar: "فانواتو" },
  VE: { en: "Venezuela, Bolivarian Republic of", ar: "فنزويلا" },
  VN: { en: "Viet Nam", ar: "فيتنام" },
  VG: { en: "Virgin Islands, British", ar: "جزر العذراء البريطانية" },
  VI: { en: "Virgin Islands, U.S.", ar: "جزر العذراء الأمريكية" },
  WF: { en: "Wallis and Futuna", ar: "واليس وفوتونا" },
  EH: { en: "Western Sahara", ar: "الصحراء الغربية" },
  YE: { en: "Yemen", ar: "اليمن" },
  ZM: { en: "Zambia", ar: "زامبيا" },
  ZW: { en: "Zimbabwe", ar: "زيمبابوي" },
};
/**
 * Gets the full name of a country from its code and language.
 * @param {string} code - The 2-letter country code (e.g., "US").
 * @param {'en' | 'ar'} language - The desired language.
 * @returns {string} The full country name or the code itself if not found.
 */
export const getCountryName = (code, language) => {
  const upperCode = code.toUpperCase();
  if (countryData[upperCode] && countryData[upperCode][language]) {
    return countryData[upperCode][language];
  }
  return code; // Fallback to the code if no translation is available
};

/**
 * يحصل على رمز الدولة (ISO alpha-2) من اسم الدولة بالإنجليزية أو العربية.
 * مفيد عندما الـ API يرجع اسم الدولة فقط (مثل السيرفر الأول SMSPool).
 * @param {string} countryName - اسم الدولة (إنجليزي أو عربي).
 * @returns {string | null} رمز من حرفين (مثل "US") أو null إن لم يُعثر على تطابق.
 */
export const getCountryCodeFromName = (countryName) => {
  if (!countryName || typeof countryName !== 'string') return null;
  const normalized = countryName.trim().toLowerCase();
  if (normalized.length === 0) return null;
  for (const code in countryData) {
    const en = (countryData[code].en || '').trim().toLowerCase();
    const ar = (countryData[code].ar || '').trim().toLowerCase();
    if (en === normalized || ar === normalized) return code;
    if (en.includes(normalized) || normalized.includes(en)) return code;
    if (ar.includes(normalized) || normalized.includes(ar)) return code;
  }
  return null;
};

/**
 * تنشئ رابطًا لصورة علم الدولة بناءً على رمز ISO.
 * تستخدم خدمة flagcdn.com لعرض صور SVG عالية الجودة.
 * @param {string} countryCode - رمز الدولة المكون من حرفين (e.g., "US", "SA").
 * @returns {string} رابط URL لصورة العلم.
 */
export const getFlagUrl = (countryCode) => {
    if (typeof countryCode !== 'string' || countryCode.trim().length !== 2) {
    // إذا كان الرمز غير صالح، نرجع رابط صورة بديلة مضمونة
    return 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Simple_Globe.svg/240px-Simple_Globe.svg.png';
  }
  // إذا كان الرمز صالحاً، ننشئ الرابط
  return `https://flagcdn.com/w160/${countryCode.toLowerCase()}.png`;
};

/**
 * Converts a 2-letter ISO country code to its corresponding flag emoji.
 * @param {string} countryCode - The 2-letter ISO 3166-1 alpha-2 country code (e.g., 'US', 'SA').
 * @returns {string} The flag emoji string, or a default flag if the code is invalid.
 */
export const getFlagEmoji = (countryCode) => {
  // Check for a valid 2-character string
  if (!countryCode || countryCode.length !== 2) {
    return '🏳️'; // Return a default white flag for invalid codes
  }
  // The formula to convert a letter to its regional indicator symbol in Unicode
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};